import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { SendTenantMailTemplate, TenantMailTemplate } from './tenant-mail-template.interface';
import { LocationQuery } from 'vue-router';
export class TenantMailTemplateService {
   async getAll(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<TenantMailTemplate>>>('/tenant-mail-templates', { params: query });
      return response.data;
   }

   async get(id: number) {
      const response = await http.get<ApiResource<TenantMailTemplate>>(`/tenant-mail-templates/${id}`);
      return response.data;
   }

   async post(tenant_mail_template: SendTenantMailTemplate, id: number) {
      const response = await http.post<ApiResource<TenantMailTemplate>>(`/tenant-mail-templates/${id}/send`, tenant_mail_template);
      return response.data;
   }
}
